import { Button, ButtonGroup } from '@material-ui/core'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchDueAmount,
  terminateProgramEnrolment,
  pauseProgramEnrolment
} from 'api'
import BaseEntity from 'app/components/BaseEntity'
import { useStyles } from 'app/components/generic/Button'
import { toddlerClubEnrolmentActions } from 'app/config'
import constants from 'app/constants'
import { eventAlert, eventEmitter } from 'app/helpers'
import {
  fetchToddlerClubEnrolmentData,
  updateClassData
} from 'app/store/actions/classEntity'
import { getCurrentMonth } from 'app/utils'

import PauseEnrolmentForm from './components/PauseEnrolmentForm'
import { columns } from './config'

import MasterModal from '../components/MasterModal'

const ToddlerClubEnrolment = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [action, setAction] = React.useState('')
  const [cancelId, setCancelId] = React.useState('')
  const [editIndex, setEditIndex] = React.useState(null)
  const [dueAmount, setDueAmount] = React.useState({
    enrolment_uuid: '',
    data: [],
    dataIndex: null,
    due: 0
  })
  const toddlerClubEnrolmentData = useSelector(
    (state) => state.classEntityReducer.toddlerClubEnrolmentData
  )
  const dispatch = useDispatch()

  const openModal = React.useCallback((action, dataIndex) => {
    setIsModalOpen(true)
    setAction(action)
    setEditIndex(dataIndex)
  }, [])

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const onActionButtonClick = (e, action, dataIndex) => {
    if (action === 'terminate_enrolment') {
      openModal('terminate_enrolment', dataIndex)
    } else if (action === 'pause_enrolment') {
      openModal('pause_enrolment', dataIndex)
    }
  }

  const onSaveClick = async (newData, action) => {
    const { uuid: enrolmentUuid } = toddlerClubEnrolmentData.data[editIndex]
    try {
      if (action === 'terminate_enrolment') {
        await terminateProgramEnrolment({
          enrolment_uuid: enrolmentUuid,
          notes: newData.notes,
          endDate: newData.end_date,
          reason: newData.reason
        })

        eventEmitter.emit(constants.CLOSE_MODAL_FORM)
        eventAlert('Enrolment Terminated Successfully', constants.SUCCESS)
        closeModal()
      } else if (action === 'pause_enrolment') {
        await pauseProgramEnrolment({
          enrolment_uuid: enrolmentUuid,
          start_date: newData.start_date,
          end_date: newData.end_date,
          reason: newData.reason
        })

        eventEmitter.emit(constants.CLOSE_MODAL_FORM)
        eventAlert('Enrolment Paused Successfully', constants.SUCCESS)
        closeModal()
      }

      const queries = JSON.parse(localStorage.getItem('filterQueries'))
      dispatch(
        fetchToddlerClubEnrolmentData(
          { ...queries },
          false,
          false,
          constants.TODDLER_CLUB_ENROLMENT
        )
      )
    } catch (error) {
      console.log(error)
      eventEmitter.emit(constants.MODAL_FORM_SAVE_ERROR, error)
      eventAlert(error.message, constants.ERROR)
    }
  }
  const classes = useStyles()
  const modifiedColumns = React.useMemo(() => {
    return [
      ...columns,
      {
        name: '',
        label: 'actions',
        disabledInForm: true,
        options: {
          disableFilter: true,
          filter: false,
          sort: false,
          customBodyRenderLite: (dataIndex) => {
            const { status, is_termination_requested } =
              toddlerClubEnrolmentData?.data[dataIndex] || {}

            return (
              status !== 'terminated' &&
              status !== 'expired' &&
              status !== 'lapsed' &&
              !is_termination_requested && (
                <>
                  {Object.keys(toddlerClubEnrolmentActions)
                    .filter(
                      (action) =>
                        !(action === 'pause_enrolment' && status === 'paused')
                    )
                    .map((action, index) => {
                      return (
                        <Button
                          style={{ marginRight: 4 }}
                          key={'ExploreEnrolment' + index}
                          title={toddlerClubEnrolmentActions[action]}
                          className={classes.button}
                          onClick={(e) => {
                            onActionButtonClick(e, action, dataIndex)
                          }}
                        >
                          {toddlerClubEnrolmentActions[action]}
                        </Button>
                      )
                    })}
                </>
              )
            )
          }
        }
      }
    ]
  }, [toddlerClubEnrolmentData])

  return (
    <>
      <BaseEntity
        entity={constants.TODDLER_CLUB_ENROLMENT}
        label={constants.TODDLER_CLUB_ENROLMENT_LABEL}
        columns={modifiedColumns}
        data={toddlerClubEnrolmentData}
        fetchData={fetchToddlerClubEnrolmentData}
        updateEntityData={updateClassData}
        createDependency
        disableDelete
        readOnly
      />
      {action === 'pause_enrolment' ? (
        <PauseEnrolmentForm
          isModalOpen={isModalOpen}
          formData={toddlerClubEnrolmentData.data[editIndex] || {}}
          onSaveClick={onSaveClick}
          closeModal={closeModal}
        />
      ) : (
        <MasterModal
          isModalOpen={isModalOpen}
          onSaveClick={onSaveClick}
          closeModal={closeModal}
          action={action}
          data={toddlerClubEnrolmentData.data[editIndex] || {}}
          onActionButtonClick={onActionButtonClick}
          setCancelId={setCancelId}
        />
      )}
    </>
  )
}

export default ToddlerClubEnrolment
